document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.lp-reviews-splide').forEach(function (el) {
    var splide = new Splide(el, {
      type: 'slide',
      perPage: 3,
      gap: '1rem',
      arrows: true,
      pagination: false,
      drag: true,
      breakpoints: {
        1024: {
          perPage: 2,
        },
        767: {
          perPage: 1,
          pagination: true,
          padding: { left: '1rem', right: '4rem' },
          gap: '0.75rem',
        },
      },
    });

    splide.on('mounted resized', function () {
      var total = splide.length;
      var perPage = splide.options.perPage;
      var arrows = el.querySelector('.splide__arrows');
      if (arrows) {
        arrows.style.display = total <= perPage ? 'none' : '';
      }
    });

    splide.mount();
  });
});
